"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Grid = void 0;
var tslib_1 = require("tslib");
var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");
var react_1 = tslib_1.__importDefault(require("react"));
var root_1 = require("./styled/root");
var Grid = function (_a) {
    var className = _a.className, testID = _a["data-testid"], children = _a.children, 
    // 👇 Removing the space props, so they don’t get passed to Grid
    // through `...rest` and cause double spacing.
    _m = _a.m, _mb = _a.mb, _ml = _a.ml, _mr = _a.mr, _mt = _a.mt, _mx = _a.mx, _my = _a.my, _p = _a.p, _pb = _a.pb, _pl = _a.pl, _pr = _a.pr, _pt = _a.pt, _px = _a.px, _py = _a.py, rest = tslib_1.__rest(_a, ["className", 'data-testid', "children", "m", "mb", "ml", "mr", "mt", "mx", "my", "p", "pb", "pl", "pr", "pt", "px", "py"]);
    return (react_1.default.createElement(root_1.Root, tslib_1.__assign({ className: className, "data-testid": testID }, rest), children));
};
var GridWithSpace = (0, ui_helper_with_space_1.withSpace)(Grid);
exports.Grid = GridWithSpace;
//# sourceMappingURL=grid.js.map